import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EActionType, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleApiErrorWithFallback } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';
import type { IPaginationRequest } from '../../types/IApiTypes';

export const ProductVersionMappingApi = {
  // Get all product version mapping items from the api
  getProductVersionMappingData: (payload: IPaginationRequest, dispatch: Dispatch) => {
    let queryParams = new URLSearchParams();
    if (payload.caller !== EActionType.Refresh) {
      queryParams = new URLSearchParams({
        [EUrlParams.Page]: String(payload.page),
        [EUrlParams.Limit]: String(payload.limit),
      });
      if (payload.searchCode) {
        queryParams.set(EUrlParams.Search, payload.searchCode);
      }
    }

    const requestBody =
      payload.caller === EActionType.Refresh && payload.searchCode
        ? { filters: { versionId: payload.searchCode } }
        : {};

    return AxiosClient.post(
      `productrelease/v1/publish-version-mapping/read?${queryParams.toString()}`,
      requestBody
    )
      .then((response) => {
        return handlePaginatedData(response, payload);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: payload.page, searchKey: payload.searchCode, caller: payload.caller },
          EAction.Read,
          EApiType.ProductVersionMappingKey
        );
      });
  },
};
